import { module } from 'stereomodularjs';
import { loadRecaptcha } from '../utils/recaptcha';

/*
USAGE:
<form
    method="post"
    data-module="ContactForm"
    data-recaptcha-site-key="SITE_KEY"
    data-recaptcha-error-msg="Translated error message"
>
    <input type="hidden" name="g-recaptcha-response" value="">
</form>
*/

export default class extends module {
    constructor(m) {
        super(m);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    init() {
        this.form = this.el;
        this.siteKey = this.form.getAttribute('data-recaptcha-site-key') || '';
        this.recaptchaErrorMsg = this.form.getAttribute('data-recaptcha-error-msg') || '';
        this.recaptchaInput = this.form.querySelector('[name="g-recaptcha-response"]');
        this.loadingEl = this.form.querySelector('.o-form__loading');
        this.recaptchaReady = null;

        this.form.addEventListener('submit', this.handleSubmit);

        if (this.siteKey) {
            this.recaptchaReady = loadRecaptcha(this.siteKey);
        }
    }

    handleSubmit(event) {
        event.preventDefault();

        if (!this.siteKey) {
            this.submitForm();
            return;
        }

        const ready = this.recaptchaReady || loadRecaptcha(this.siteKey);

        ready
            .then(() => this.runRecaptcha())
            .catch(() => {
                if (this.recaptchaErrorMsg) {
                    alert(this.recaptchaErrorMsg);
                }
            });
    }

    runRecaptcha() {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(this.siteKey, { action: 'contact' }).then((token) => {
                if (this.recaptchaInput) {
                    this.recaptchaInput.value = token;
                }
                this.submitForm();
            });
        });
    }

    showLoading() {
        this.form.classList.add('is-submitting');
        if (this.loadingEl) {
            this.loadingEl.style.display = 'block';
        }
    }

    submitForm() {
        this.showLoading();
        this.form.submit();
    }

    destroy() {
        this.form.removeEventListener('submit', this.handleSubmit);
    }
}
